import React, {useState} from "react"
import "./styles/ProviderInfo.css"
import ProviderInterface from "../../interfaces/ProviderInterface";

const ProviderInfo: React.FC<{provider: ProviderInterface}> = (props) => {

    const [showAll, turnShowAll] = useState<boolean>(false)

    return (
        <div className="AmoTools__Provider">
            <span className="AmoTools__Provider__Title">{props.provider.field_name}</span>

            <div className="AmoTools__Provider__Info">
                <span className="AmoTools__Provider__Info__Name">{props.provider.value.name}</span>

                <div className="AmoTools__Provider__Info__List">
                    <div className="AmoTools__Provider__Info__List__Item">
                        <span>Адрес:</span>
                        <span>{props.provider.value.address}</span>
                    </div>
                    <div className="AmoTools__Provider__Info__List__Item">
                        <span>ИНН / КПП:</span>
                        <span>{props.provider.value.vat_id} / {props.provider.value.kpp}</span>
                    </div>
                    {showAll ? (
                       <>
                           <div className="AmoTools__Provider__Info__List__Item">
                               <span>БИК:</span>
                               <span>{props.provider.value.bank_code}</span>
                           </div>
                           <div className="AmoTools__Provider__Info__List__Item">
                               <span>ОГРН:</span>
                               <span>{props.provider.value.tax_registration_reason_code}</span>
                           </div>
                       </>
                    ): ""}
                </div>
            </div>

            <div className="AmoTools__Provider__ShowMore">
                <span
                    className="AmoTools__Provider__ShowMore__Inner"
                    onClick={(e) => {turnShowAll(!showAll)}}
                >
                    {showAll ? "Свернуть реквизиты" : "Показать все реквизиты"}
                </span>
            </div>
        </div>
    )

}

export default ProviderInfo